import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import NullValue from '../../../../../molecules/NullValue'
import Markup from '../../../../../atoms/Markup'
import FlexRow from '../../../../../molecules/FlexRow'
import SydButton from '../../../../../commonDesign/Button'
import DescribeDatasourceDialog from '../../dialogs/DescribeDatasourceDialog'

function DatasourceDescription ({ datasource }) {
  const dataSourceDialog = useRef(null)

  return (
    <div className='p-sm'>
      <FlexRow className='justify-end'>
        <SydButton
          icon='edit'
          size='sm'
          onClick={() => dataSourceDialog.current.open(datasource)}
        >
          Edit
        </SydButton>
      </FlexRow>
      {datasource.description ? (
        <Markup value={datasource.description} type='markdown' />
      ) : (
        <NullValue value='No Description' />
      )}
      <DescribeDatasourceDialog ref={dataSourceDialog} />
    </div>
  )
}

DatasourceDescription.propTypes = {
  datasource: PropTypes.shape({
    description: PropTypes.string
  })
}

export default DatasourceDescription
